import React from "../../../__compat__/react/main.entry.mjs.mjs";
import { GenericOption } from "../GenericOption/GenericOption.mjs.mjs";
export const Checkbox = React.forwardRef(function Checkbox(props, ref) {
    return (React.createElement(GenericOption, { ...props, type: "checkbox", ref: ref }, props.children));
});
//# sourceMappingURL=Checkbox.mjs.mjs.map